import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Close } from "@styled-icons/material/Close"
import {
  shouldDisplayIntroInfo,
  setDidDisplayIntroInfo
} from "../helpers/sessionUtil"
import {
  FlexColumn,
  FullSlider,
  theme,
  inBrowser,
} from "../helpers/omniElements"
import MobileAppPreview1 from "../images/mobile_preview/EGR_FlashPage_1.jpg"
import MobileAppPreview2 from "../images/mobile_preview/EGR_FlashPage_2.jpg"
import MobileAppPreview3 from "../images/mobile_preview/EGR_FlashPage_3.jpg"
import MobileAppPreview4 from "../images/mobile_preview/EGR_FlashPage_4.jpg"
import MobileAppPreview5 from "../images/mobile_preview/EGR_FlashPage_5.jpg"

import TabAppPreview1 from "../images/tab_preview/EGR_FlashPage_1.jpg"
import TabAppPreview2 from "../images/tab_preview/EGR_FlashPage_2.jpg"
import TabAppPreview3 from "../images/tab_preview/EGR_FlashPage_3.jpg"
import TabAppPreview4 from "../images/tab_preview/EGR_FlashPage_4.jpg"
import TabAppPreview5 from "../images/tab_preview/EGR_FlashPage_5.jpg"

import useWindowDimensions from "../helpers/windowDimensions"

const ModalBackground = styled.div`
  display: visible; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  padding: ${props =>
    props.isFullScreenOnMobile || props.isFullScreen
      ? `0rem`
      : props.padding
        ? props.padding
        : "8.6rem 0rem"};
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "rgba(0,0,0,0.4)"};
  @media only screen and (min-width: 700px) {
    padding: ${props => (props.isFullScreen ? `0rem` : "12rem 0rem")};
  }
  ${props =>
    props.centerContent
      ? "display: flex; justify-content: center; align-items: center;"
      : ""}
`

const ModalContainer = styled.div`
    ${props => props.inHeightLimit ? "height: 100%;" : ""}
    width: 40%;
    max-width: 400px; 
    justify-content: center;
    user-select: none;
    margin: auto;
    border-radius: .2rem;

    /* width: ${props =>
    props.isFullScreenOnMobile || props.isFullScreen ? `90%` : "90%"}; */
    width: 90%;
    display: flex;
    flex-direction: column;
    ${props => props.style}
    
    @media only screen and (min-width: 790px) {
        max-width: 564px; //based on images dimension
    }
        

`

const SplashImageBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const SplashImageObj = styled.img`
  // box-shadow: 0 .1rem .4rem  rgba(0,0,0, .2);
  display: block;
  width: 100%;
  height: auto;
  cursor: ${props => (props.clickable ? "pointer" : "auto")};

`

const CloseButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  position: relative;
  top: 1.7rem;
  left: 1.5rem;
  justify-content: flex-end;
  width: ${props => (props.isMobile ? "100%" : "92.5%")}; 
  z-index: 9;
`

const CloseButtonWrapper = styled.div`
  background: rgba(255, 255, 255, 0.9);
  width: fit-content;
  border-radius: 2rem;
  padding: 0.3rem;
`

const IntroModal = props => {
  var ref = React.createRef()
  const [displayIntroInfo, setDisplayIntroInfo] = useState(
    shouldDisplayIntroInfo()
  )
  const mobileImages = [
    MobileAppPreview1,
    MobileAppPreview2,
    MobileAppPreview3,
    MobileAppPreview4,
    MobileAppPreview5
  ]
  const desktopImages = [
    TabAppPreview1,
    TabAppPreview2,
    TabAppPreview3,
    TabAppPreview4,
    TabAppPreview5
  ]
  const { width, height } = useWindowDimensions()
  const isMobile = width < 790
  const inHeightLimit = height > 750


  return displayIntroInfo ? (
    <ModalBackground
      ref={ref}
      isFullScreenOnMobile={true}
      onClick={e => {
        if (e.target === ref.current) {
          {
          }
        }
      }}
    >
      <ModalContainer isFullScreenOnMobile={true} inHeightLimit={inHeightLimit}>
        <CloseButtonContainer isMobile={isMobile}>
          <CloseButtonWrapper>
            <Close
              cursor={"pointer"}
              size={"2rem"}
              color={"#000"}
              onClick={e => {
                setDisplayIntroInfo(1)
                setDidDisplayIntroInfo(1)
                setDisplayIntroInfo(shouldDisplayIntroInfo())
              }}
            />
          </CloseButtonWrapper>
        </CloseButtonContainer>
        <FlexColumn width={isMobile ? "100%" : "85%"} margin={"0 auto"}>
          <FullSlider
            slides={1}
            dots={true}
            dotsBottomOffset={".6rem"}
            dotsActiveColor={"#66C3FC"}
            dotsPassiveColor={"white"}
            dotsWidth={"1.2rem"}
            dotsFontSize={".8rem"}
            autoplay
          >
            {(inBrowser && isMobile ? mobileImages : desktopImages).map(
              (data, index) => {
                return <SplashImageObj src={data} key={index} alt={data} />
              }
            )}
          </FullSlider>
        </FlexColumn>
      </ModalContainer>
    </ModalBackground>
  ) : null
}

export default IntroModal
